// ═══════════════════════════════════════════════════════════════
//  本地存储：最高分 / 最高楼层 / 已通关楼层
//  使用 localStorage，刷新或重开浏览器后依然保留。
// ═══════════════════════════════════════════════════════════════

export const HIGH_SCORE_KEY = 'dungeon.highScore';
export const HIGH_FLOOR_KEY = 'dungeon.highFloor';
/** 已通关的最高楼层（选关系统使用；0 = 尚未通关任何层） */
export const CLEARED_FLOOR_KEY = 'dungeon.clearedFloor';

/** 读取一个非负整数（不存在 / 非法 / 不可用时返回 0） */
export function loadNumber(key: string): number {
  try {
    const v = Number(localStorage.getItem(key));
    return Number.isFinite(v) && v > 0 ? v : 0;
  } catch {
    // 隐私模式等场景下 localStorage 可能不可用
    return 0;
  }
}

/** 写入一个整数（写入失败时静默忽略） */
export function saveNumber(key: string, value: number): void {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* 忽略 */
  }
}
